import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { User } from '../../services/userService';
import { ScheduledSpot } from '../../services/scheduledSpotService';
import Spot from './Spot';

export default function ScheduledSpotAmendModal({ onCancel, onConfirm, company }) {
    const { t } = useTranslation();
    const [localModel, setLocalModel] = useState(undefined);
    const [error, setError] = useState(undefined);
    const [actionInProgress, setActionInProgress] = useState(false);

    // Initialise editable state each time the modal opens
    useEffect(() => {
        let sub = ScheduledSpot.subscribe(() => {
            if (ScheduledSpot.scheduledSpotToAmend) {
                setLocalModel(JSON.parse(JSON.stringify(ScheduledSpot.scheduledSpotToAmend)));
            } else {
                setActionInProgress(false);
                setLocalModel(undefined);
            }
        });
        return (() => {
            ScheduledSpot.unsubscribe(sub);
        });
    }, []);

    const handleCancel = () => {
        if (!actionInProgress) {
            setActionInProgress(true);
            onCancel();
        }
    };

    const handleConfirm = () => {
        if (!actionInProgress && !error) {
            setActionInProgress(true);
            onConfirm({ company, product: 'SCHEDULED_SPOT', ...localModel });
        }
    };

    return (
        <Modal show={ScheduledSpot.isAmendingScheduledSpot()} onHide={handleCancel} centered className="td-modal modal-lg">
            <Modal.Header>
                <Modal.Title><h2>{t('td.fx.ticket.scheduledspot.amend.title')}</h2></Modal.Title>
            </Modal.Header>
            <Modal.Body className="td-modal-body-shown">
                {localModel && company && (
                    <>
                        <div>{t('td.fx.ticket.lbl.Company')}</div>
                        <h4>
                            {company.name}
                        </h4>
                        <Spot
                            model={localModel}
                            setModel={(m) => setLocalModel(m)}
                            permissions={User.user?.permissions || {}}
                            company={company}
                            setError={setError}
                            product="SCHEDULED_SPOT"
                        />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn td-btn-secondary-clear"
                    onClick={handleCancel}
                    disabled={actionInProgress}
                >
                    {t('td.fx.ticket.scheduledspot.cancel')}
                </Button>
                <Button
                    className="btn td-btn-primary-light"
                    onClick={handleConfirm}
                    disabled={actionInProgress || !!error}
                >
                    {t('td.fx.ticket.scheduledspot.amend.confirm')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
